import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import App from "./App.vue";
import { useAuthStore } from "@/stores/authStore";
import { useLanguageStore } from "@/stores/languageStore";
import i18n from "./i18n";

// Import styles
import "../resources/css/app.css";

// Create Vue app instance
const app = createApp(App);

// Use plugins
app.use(createPinia());
app.use(router);
app.use(i18n);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
    console.error("Global error:", err);
    console.error("Component:", vm);
    console.error("Info:", info);

    // You could send this to an error tracking service
    if (import.meta.env.PROD) {
        // Send to error tracking service
    }
};

// Global warning handler
app.config.warnHandler = (msg, vm, trace) => {
    console.warn("Global warning:", msg);
    console.warn("Component:", vm);
    console.warn("Trace:", trace);
};

// Initialize auth store
const authStore = useAuthStore();
authStore.initializeAuth();

// Initialize language store
const languageStore = useLanguageStore();
languageStore.initializeLanguage();

// Mount app
app.mount("#app");

// Enable devtools in development
if (import.meta.env.DEV) {
    (app.config as any).devtools = true;
    (app.config as any).performance = true;
}

// Handle unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
    console.error("Unhandled promise rejection:", event.reason);

    if (import.meta.env.PROD) {
        // Send to error tracking service
    }
});

// Handle uncaught errors
window.addEventListener("error", (event) => {
    console.error("Uncaught error:", event.error);

    if (import.meta.env.PROD) {
        // Send to error tracking service
    }
});
